import * as React from 'react';
import styled from 'styled-components';
import {
	dashboardHeaderHeightV2,
	bodyFixedElementsZIndex,
	appHeaderWrapperHeightV2,
	tabletPortraitMinWidth,
	tabletLandscapeMinWidth,
	tabletLandscapePadding,
	greyBackground,
	whiteColour,
	appHeaderGap,
	slateGrey
} from '../../cssConstants';

import { EventDetailItems, EventSessionItems } from '../../../core/enums';
import { agendaTab, detailsTab, homeTab, networkTab, notesTab, qaTab, socialTab } from './guidedTour/stepToLocationMap';

const TabMenu = <T extends Record<string, string>>({
	enumType,
	selectedTabItem,
	onTabItemClick,
	largeTopPage = false,
	excludeItems = [],
	ref
}: Props<T>) => {
	const tabItems = (Object.values(enumType) as T[keyof T][]).filter((item) => !excludeItems.includes(item));

	return (
		<TabContainer $largeTopPage={largeTopPage} ref={ref}>
			<TabItemBox>
				{tabItems.map((item) => (
					<TabItem
						key={item}
						$isActive={selectedTabItem === item}
						$tabCount={tabItems.length}
						onClick={() => onTabItemClick(item)}
						data-joyride={joyrideIds[item]}
					>
						{item}
					</TabItem>
				))}
			</TabItemBox>
		</TabContainer>
	);
};

export default TabMenu;

interface Props<T extends Record<string, string>> {
	enumType: T;
	selectedTabItem: T[keyof T];
	onTabItemClick: (tabItem: T[keyof T]) => void;
	largeTopPage?: boolean;
	excludeItems?: T[keyof T][];
	ref?: React.Ref<HTMLDivElement>;
}

const joyrideIds: Record<string, string> = {
	[EventDetailItems.Home]: homeTab,
	[EventDetailItems.Agenda]: agendaTab,
	[EventDetailItems.Network]: networkTab,
	[EventDetailItems.Social]: socialTab,
	[EventSessionItems.Details]: detailsTab,
	[EventSessionItems.Notes]: notesTab,
	[EventSessionItems.QA]: qaTab
};

const TabContainer = styled.div<{ $largeTopPage: boolean }>`
	position: fixed;
	margin: 0 auto;
	left: 0;
	width: 100%;
	top: ${({ $largeTopPage }) => ($largeTopPage ? dashboardHeaderHeightV2 : appHeaderWrapperHeightV2)};
	z-index: ${bodyFixedElementsZIndex};
	padding: ${appHeaderGap} 16px;
	justify-content: center;
	align-items: center;
	background-color: ${greyBackground};

	@media (min-width: ${tabletLandscapeMinWidth}) {
		padding-left: ${tabletLandscapePadding};
		padding-right: ${tabletLandscapePadding};
	}
`;

const TabItemBox = styled.div`
	height: 45px;
	display: flex;
	margin: 0;
	border-radius: 12px;
	background-color: #eeeeee;
`;

const TabItem = styled.div<{ $isActive: boolean; $tabCount: number }>`
	margin: 2px;
	width: calc((100% / ${({ $tabCount }) => $tabCount}) - 4px);
	text-align: center;
	font-size: 12px;
	line-height: 16px;
	letter-spacing: 0.5px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 10px;
	font-weight: ${({ $isActive }) => ($isActive ? '600' : '500')};
	background: ${({ $isActive, theme }) => ($isActive ? theme.primaryBackground : '#EEEEEE')};
	color: ${({ $isActive }) => ($isActive ? whiteColour : slateGrey)};
	cursor: pointer;
	transition:
		background 0.3s ease,
		color 0.3s ease;

	&:hover {
		background: ${({ $isActive, theme }) => ($isActive ? theme.primaryBackground : '#EEEEEE')};
	}

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 14px;
	}
`;
